import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import LoaderCstm from "../../Loader";
import { wait } from "../../../helper/common";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./Authe.module.scss";
import { useTranslation } from "react-i18next";
import "../../../i18n";
import { useLanguage } from "../../../hooks/useLanguage";

const AuthLayout = () => {
  // const { t, i18n } = useTranslation();
  const t = useLanguage();
  const { loading } = useSelector(({ Auth }) => ({
    user: Auth.user,
  }));

  // const changeLanguage = (lang) => {
  //   i18n.changeLanguage(lang);
  //   localStorage.setItem("lang", lang);
  // };

  // While checking auth, show a loading indicator
  if (loading) {
    return <LoaderCstm />;
  }

  wait(1000);
  return (
    <>
      {/* <main> */}
      <section
        className={`${styles.authentication} authentication text-center py-5 position-relative d-flex align-items-center justify-content-center`}
      >
        {/* <p
          className="m-0 text-white position-relative"
          style={{ zIndex: 999999 }}
        >
          {t("welcome")}
        </p>
        <button
          style={{ zIndex: 999999 }}
          className="border-0 p-0 position-relative"
          onClick={() => i18n.changeLanguage("en")}
        >
          change
        </button> */}
        <Container>
          <Row className="justify-content-center">
            <Col lg="5" md="6" sm="10">
              <div className={`${styles.authFormWrpper} p-4`}>
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* </main> */}
    </>
  );
};

export default AuthLayout;
